export default __webpack_public_path__ + "static/media/synth-active.506d3f0d.svg";